"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _EditorSidebar = _interopRequireDefault(require("./EditorSidebar"));

var _GraphPanel = _interopRequireDefault(require("./GraphPanel"));

var _TextPanel = _interopRequireDefault(require("./TextPanel"));

var _UploadPanel = _interopRequireDefault(require("./UploadPanel"));

var _HelpPanel = _interopRequireDefault(require("./HelpPanel"));

var _Panel = _interopRequireDefault(require("./Panel"));

var _default = {
  EditorSidebar: _EditorSidebar.default,
  GraphPanel: _GraphPanel.default,
  TextPanel: _TextPanel.default,
  HelpPanel: _HelpPanel.default,
  UploadPanel: _UploadPanel.default,
  Panel: _Panel.default,

  install(Vue) {
    Vue.component(_EditorSidebar.default.name, _EditorSidebar.default);
    Vue.component(_HelpPanel.default.name, _HelpPanel.default);
    Vue.component(_GraphPanel.default.name, _GraphPanel.default);
    Vue.component(_TextPanel.default.name, _TextPanel.default);
    Vue.component(_UploadPanel.default.name, _UploadPanel.default);
    Vue.component(_Panel.default.name, _Panel.default);
  }

};
exports.default = _default;